import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Modal, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

const AgregarCuentaModal = ({ show, onHide, newAccount, onChange, onSave, cuentasData, catalogoSAT = [], parentReadonly }) => {

  const cuentasFlat = cuentasData || [];

  const cuentasOptions = cuentasFlat.map(c => ({
    value: c.idCuentaContable,
    label: `${c.vCodigoCuenta} - ${c.vNombreCuenta}`,
    node: c
  }));

  const satOptions = catalogoSAT.map(c => ({
    value: c.idCatCuentaContable,
    label: `${c.vCodigoCuenta} - ${c.vNombreCuenta}`,
    node: c
  }));

  const handleCodigoChange = (e) => {
    onChange({
      target: {
        name: 'vCodigoCuenta',
        value: e.target.value.replace(/[^0-9-]/g, '')
      }
    });
  };

  const handleCuentaPadreSelect = (selectedOption) => {
    const found = selectedOption ? selectedOption.node : null;
    
    onChange({
      target: {
        name: 'idCuentaPadre',
        value: found ? found.idCuentaContable : ''
      }
    });

    onChange({
      target: {
        name: 'iNivel',
        value: found ? parseInt(found.iNivel || 1, 10) + 1 : 1
      }
    });
  };

  const handleSATSelect = (selectedOption) => {
    const found = selectedOption ? selectedOption.node : null;
    onChange({
      target: {
        name: 'idCatCuentaContableSAT',
        value: found ? found.idCatCuentaContable : ''
      }
    });
  };

  const parentAccount = cuentasFlat.find(c => c.idCuentaContable?.toString() === newAccount.idCuentaPadre?.toString());
  const satAccount = catalogoSAT.find(c => c.idCatCuentaContable?.toString() === newAccount.idCatCuentaContableSAT?.toString());

  const forcedNaturaleza = parentAccount ? parentAccount.vNaturaleza : (satAccount ? satAccount.vNaturaleza : null);

  useEffect(() => {
    if (forcedNaturaleza && newAccount.vNaturaleza !== forcedNaturaleza) {
      onChange({ target: { name: 'vNaturaleza', value: forcedNaturaleza } });
    }
  }, [forcedNaturaleza]);



  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{newAccount.idCuentaContable ? 'Editar Cuenta Contable' : 'Agregar Cuenta Contable'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Código de Cuenta Propio <span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="vCodigoCuenta" value={newAccount.vCodigoCuenta} onChange={handleCodigoChange} placeholder="Ej: 100-01-00" />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nombre de la Cuenta <span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="vNombreCuenta" value={newAccount.vNombreCuenta} onChange={onChange} placeholder="Ej: Activo a Corto Plazo" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cuenta Padre (Búsqueda Propia)</Form.Label>
                <Select
                  options={cuentasOptions}
                  value={cuentasOptions.find(o => o.value?.toString() === newAccount.idCuentaPadre?.toString()) || null}
                  onChange={handleCuentaPadreSelect}
                  placeholder="Buscar cuenta..."
                  isClearable
                  isDisabled={parentReadonly || newAccount.iTipoNivelCuenta?.toString() === "1"}
                  noOptionsMessage={() => "No se encontraron cuentas"}
                />
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nivel <span className="text-danger">*</span></Form.Label>
                <Form.Control type="number" name="iNivel" value={newAccount.iNivel} onChange={onChange} min="1" disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Naturaleza <span className="text-danger">*</span></Form.Label>
                <Form.Select name="vNaturaleza" value={forcedNaturaleza || newAccount.vNaturaleza} onChange={onChange} disabled={!!forcedNaturaleza}>
                  <option value="D">Deudora (D)</option>
                  <option value="A">Acreedora (A)</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Tipo de nivel de cuenta <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="iTipoNivelCuenta"
                  value={newAccount.iTipoNivelCuenta?.toString() || "1"}
                  onChange={(e) => {
                    onChange(e);
                    if (e.target.value === "1") {
                      onChange({ target: { name: 'idCuentaPadre', value: '' } });
                      onChange({ target: { name: 'iNivel', value: 1 } });
                    }
                  }}
                >
                  <option value="1">Título</option>
                  <option value="2">Mayor / Agrupadora</option>
                  <option value="3">De Detalle</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Código Agrupador SAT <span className="text-danger">*</span></Form.Label>
                <Select
                  options={satOptions}
                  value={satOptions.find(o => o.value?.toString() === newAccount.idCatCuentaContableSAT?.toString()) || null}
                  onChange={handleSATSelect}
                  placeholder="Buscar código SAT..."
                  isClearable
                  noOptionsMessage={() => "No se encontraron códigos SAT"}
                />
                <Form.Text className="text-muted">
                    Debes vincular obligatoriamente tu cuenta a una cuenta oficial del SAT.
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="primary" onClick={onSave}>
          {newAccount.idCuentaContable ? 'Guardar Cambios' : 'Guardar Cuenta'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AgregarCuentaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  newAccount: PropTypes.shape({
    idCuentaPadre: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idCatCuentaContableSAT: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vNaturaleza: PropTypes.string,
    idCuentaContable: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vCodigoCuenta: PropTypes.string,
    vNombreCuenta: PropTypes.string,
    iTipoNivelCuenta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    iNivel: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  cuentasData: PropTypes.array.isRequired,
  catalogoSAT: PropTypes.array,
  parentReadonly: PropTypes.bool
};

export default AgregarCuentaModal;
